import angular from 'angular'
import React from 'react'
import 'react-dom'
import { emitter } from '../../../util.js'

angular.module('pub.bundle.step4.react', []).factory('TableStep4', TableStep4)

function TableStep4(
  $stateParams,
  $q,
  SetsService,
  CollectiblesService,
  OddsService,
  ChannelsService,
  BundleService,
  BundleCache,
) {
  return React.createClass({
    displayName: 'TableStep4',
    propTypes: {
      s3: React.PropTypes.string,
    },
    getDefaultProps: function () {
      return { s3: '' }
    },
    getInitialState: function () {
      return {
        set: {},
        channels: [],
        sets: [],
        collectibles: [],
        odds: [],
        bundle: {},
        models: [],
        s3: '',
        stateColapse: false,
        showSoldOut: true,
        productType: null,
        edition: null,
        setType: null,
      }
    },
    componentDidMount: function () {
      var promises = {
        channels: ChannelsService.get(),
      }

      if ($stateParams.parentId !== '0') {
        promises.set = SetsService.get(parseInt($stateParams.parentId))
      }

      $q.all(promises).then(success.bind(this))

      function success(result) {
        var channels = result.channels.results
        var set = null
        if (result.set) {
          set = result.set.results
        }
        for (var i = 0; i < channels.length; i++) {
          channels[i].o = 1
          channels[i].sets = []
          channels[i].expand = false
          channels[i].colapse = false
          if (set) {
            if (channels[i].id === set['id-ch']) {
              channels.remove(channels[i])
              if (i === 0) {
                i = -1
              } else {
                i = i - 1
              }
            }
          }
        }
        for (var i = 0; i < channels.length; i++) {
          if (channels[i].sets === undefined) {
            channels[i].sets = []
          }
        }

        this.setState({
          channels: channels,
        })
      }

      emitter.on('updateData', (data) => {
        this.setState({
          productType: data.productType,
          edition: data.edition,
          setType: data.setType,
        })
        this.collapseAllSet()
      })

      emitter.on('showSoldOut', (data) => {
        this.setState({
          showSoldOut: data.status,
        })
        this.collapseAllSet()
      })
    },
    componentWillUnmount: function () {
      emitter.off('updateData')
      emitter.off('showSoldOut')
    },
    dataCollapseChannel: function (index) {
      if (this.state.stateColapse) {
        this.colapseChannel(index, false, done.bind(this))
      } else {
        this.colapseChannel(index, true, done.bind(this))
      }
      function done() {
        this.setState({
          stateColapse: !this.state.stateColapse,
        })
      }
    },
    dataCollapseSet: function (indexDad, index) {
      if (this.state.stateColapse) {
        this.colapseSet(indexDad, index, false, done.bind(this))
      } else {
        this.colapseSet(indexDad, index, true, done.bind(this))
      }
      function done() {
        this.setState({
          stateColapse: !this.state.stateColapse,
        })
      }
    },
    colapseChannel: function (index, isSelect, cb) {
      var channels = this.state.channels
      if (channels[index].colapse && isSelect === false) {
        channels[index].expand = false
        channels[index].colapse = false
        this.setState({
          channels: channels,
        })
        cb()
        return
      } else if (channels[index].colapse && isSelect) {
        cb()
        return
      }

      channels[index].expand = true
      var id = channels[index].id
      var promises = {
        sets: SetsService.getChannelId(id),
      }

      $q.all(promises).then(success.bind(this))

      function success(result) {
        var sets = result.sets.results
        for (var i = 0; i < sets.length; i++) {
          sets[i].o = 1
          sets[i].q = []
          sets[i].expand = false
          sets[i].colapse = false
        }

        channels[index].sets = sets
        channels[index].expand = false
        channels[index].colapse = !channels[index].colapse
        this.setState({
          channels: channels,
          sets: sets,
        })
        cb()
      }
    },
    colapseSet: function (indexDad, index, isSelect, cb) {
      var sets = this.state.channels[indexDad].sets
      if (sets[index].colapse && isSelect === false) {
        sets[index].expand = false
        sets[index].colapse = false
        this.state.channels[indexDad].sets = sets
        this.setState({
          channels: this.state.channels,
        })
        cb()
        return
      } else if (sets[index].colapse && isSelect) {
        cb()
        return
      }

      sets[index].expand = true
      var id = sets[index].id
      var promises = {
        collectibles: CollectiblesService.getSetId(id),
        odds: OddsService.get($stateParams.id),
      }

      $q.all(promises).then(success.bind(this))

      function success(result) {
        var collectibles = result.collectibles.results
        var odds = result.odds.results
        var len = collectibles.length
        var lenOdd = odds.length
        for (var i = 0; i < len; i++) {
          collectibles[i].o = 1
          collectibles[i].progress = 0
          collectibles[i].printCount = 0

          if (collectibles[i].t !== '') {
            collectibles[i].progress += 1
          }
          if (collectibles[i].e !== 0) {
            collectibles[i].progress += 1
          }
          if (collectibles[i].bc !== 0) {
            collectibles[i].progress += 1
          }
          if (collectibles[i]['img-t'] !== '') {
            collectibles[i].progress += 1
          }

          collectibles[i].printCount = collectibles[i].bc * window.Math.pow(collectibles[i].em, collectibles[i].e - 1)
          if (isNaN(collectibles[i].printCount)) {
            collectibles[i].printCount = 0
          }

          if (odds.length === 0) {
            collectibles[i].tog = false
          } else {
            for (var j = 0; j < lenOdd; j++) {
              if (collectibles[i].id === odds[j]['id-q']) {
                collectibles[i].tog = true
              }
            }
            if (collectibles[i].tog === undefined) {
              collectibles[i].tog = false
            }
          }
        }

        collectibles = _.orderBy(collectibles, 'n')
        if (this.state.productType && this.state.productType?.length > 0) {
          // I have collectibles an array of objects and I want to filter it by the productType that is array of numbers
          collectibles = _.filter(collectibles, (collectible) => this.state.productType.includes(collectible['k-prod']))
        }
        if (this.state.edition && this.state.edition?.length > 0) {
          collectibles = _.filter(collectibles, (collectible) => this.state.edition.includes(collectible['e']))
        }
        if (this.state.setType && this.state.setType?.length > 0) {
          collectibles = _.filter(collectibles, (collectible) => this.state.setType.includes(collectible?.s['k']))
        }
        if (!this.state.showSoldOut) {
          collectibles = _.filter(collectibles, (collectible) => collectible['st'] !== 2)
        }

        sets[index].q = collectibles
        sets[index].expand = false
        sets[index].colapse = !sets[index].colapse
        this.state.channels[indexDad].sets = sets

        this.setState({
          channels: this.state.channels,
          odds: odds,
          collectibles: collectibles,
        })
        cb()
      }
    },
    collapseAllSet: function () {
      this.state.channels.forEach((channel) => {
        channel.sets.forEach((set) => {
          set.expand = false
          set.colapse = false
        })
      })
      this.setState({
        channels: this.state.channels,
      })
    },
    toogleChange: function (index, indexDad, indexSet) {
      var setDad = angular.copy(this.state.channels[indexDad].sets[indexSet])
      setDad.q = []
      this.state.channels[indexDad].sets[indexSet].q[index].tog =
        !this.state.channels[indexDad].sets[indexSet].q[index].tog
      this.state.channels[indexDad].sets[indexSet].q[index].tog === true
        ? this.add(this.state.channels[indexDad].sets[indexSet].q[index], setDad)
        : this.remove(
            this.state.channels[indexDad].sets[indexSet].q[index],
            setDad,
            index,
            indexDad,
            indexSet,
          )
    },
    saveAll: function (indexDad, index) {
      this.colapseSet(indexDad, index, this.state.stateColapse, done.bind(this))

      function done() {
        this.setState({
          stateColapse: true,
        })
        var isSelectAll = true
        var promise = []
        var oddsDeleted = []
        var channels = this.state.channels
        var odds = this.state.odds
        var models = this.state.models

        for (var i = 0; i < channels[indexDad].sets[index].q.length; i++) {
          if (channels[indexDad].sets[index].q[i].tog === false) {
            channels[indexDad].sets[index].q[i].tog = true
            var setDad = angular.copy(channels[indexDad].sets[index])
            setDad.q = []
            if (channels[indexDad].sets[index].q[i].tog) {
              this.addCache(channels[indexDad].sets[index].q[i], setDad)
            }
            isSelectAll = false
          }
        }

        if (models.length > 0) {
          OddsService.save(parseInt($stateParams.id), models).then(
            successFirst.bind(this),
            errorFirst.bind(this),
          )

          function successFirst(result) {
            var oddsResult = result.results
            for (var i = 0; i < oddsResult.length; i++) {
              odds.push(oddsResult[i])
            }
            models = []
            this.setState({
              channels: channels,
              odds: odds,
              models: models,
            })
            this.forceUpdate()
            toastr.success('Saved!')
          }

          function errorFirst(result) {
            for (var i = 0; i < channels[indexDad].sets[index].q.length; i++) {
              channels[indexDad].sets[index].q[i].tog = false
            }
            this.setState({
              channels: channels,
              odds: odds,
              models: models,
            })
            this.forceUpdate()
            if (result.error.message.indexOf('pk_collectible_odds') !== -1) {
              swal('Any of these collectibles_odds are already linked')
            } else {
              swal(result.error.message)
            }
          }
        } else if (models.length === 0 && isSelectAll) {
          for (var i = 0; i < channels[indexDad].sets[index].q.length; i++) {
            channels[indexDad].sets[index].q[i].tog = false
            var itemDelete
            var len = odds.length
            for (var j = 0; j < len; j++) {
              if (odds[j]['id-q'] === channels[indexDad].sets[index].q[i].id) {
                itemDelete = odds[j]
                oddsDeleted.push(itemDelete)
                break
              }
            }

            if (itemDelete.id !== undefined) {
              promise.push(OddsService.deleteOdd(itemDelete.id))
            }
          }

          $q.all(promise).then(success.bind(this), error.bind(this))

          function success(result) {
            for (var i = 0; i < oddsDeleted.length; i++) {
              odds.remove(oddsDeleted[i])
            }
            oddsDeleted = []
            this.setState({
              channels: channels,
              odds: odds,
              models: models,
            })
            this.forceUpdate()
          }

          function error(result) {
            for (var i = 0; i < channels[indexDad].sets[index].q.length; i++) {
              channels[indexDad].sets[index].q[i].tog = true
            }
            this.setState({
              channels: channels,
              odds: odds,
              models: models,
            })
            this.forceUpdate()
            swal(result.error.message)
          }
        }
      }
    },
    addCache: function (item, setDad) {
      var model = {
        'id-b': parseInt($stateParams.id),
        'id-s': parseInt($stateParams.parentId),
        o: 1000,
        'id-q': item.id,
        t: item.t,
        'img-t': item['img-t'],
        cr: item.cr,
      }

      if (this.state.odds.length === 0) {
        setDad.q.push(model)
        this.state.models.push(model)
        BundleCache.addOddsOtherChannels(setDad)
        this.setState({
          models: this.state.models,
        })

        return
      }

      var len = this.state.odds.length
      for (var i = 0; i < len; i++) {
        if (this.state.odds[i]['id-q'] !== item.id) {
          setDad.q.push(model)
          this.state.models.push(model)
          BundleCache.addOddsOtherChannels(setDad)
          this.setState({
            models: this.state.models,
          })
          return
        }
      }
    },
    add: function (item, setDad) {
      var model = {
        'id-b': parseInt($stateParams.id),
        'id-s': parseInt($stateParams.parentId),
        o: 1000,
        'id-q': item.id,
        t: item.t,
        'img-t': item['img-t'],
        cr: item.cr,
      }

      if (this.state.odds.length === 0) {
        OddsService.save(model['id-b'], [model]).then(success.bind(this))

        function success(result) {
          model.id = result.results[0].id
          setDad.q.push(model)
          this.state.odds.push(model)
          BundleCache.addOddsOtherChannels(setDad)
          this.setState({
            odds: this.state.odds,
          })
        }

        return
      }

      var len = this.state.odds.length
      for (var i = 0; i < len; i++) {
        if (this.state.odds[i]['id-q'] !== item.id) {
          OddsService.save(model['id-b'], [model]).then(success.bind(this))

          function success(result) {
            model.id = result.results[0].id
            setDad.q.push(model)
            this.state.odds.push(model)
            BundleCache.addOddsOtherChannels(setDad)
            this.setState({
              odds: this.state.odds,
            })
          }

          return
        }
      }
    },
    remove: function (item, setDad, index, indexDad, indexSet) {
      var itemDelete
      var len = this.state.odds.length
      for (var i = 0; i < len; i++) {
        if (this.state.odds[i]['id-q'] === item.id) {
          itemDelete = this.state.odds[i]
          break
        }
      }

      if (itemDelete.id === undefined) {
        return
      }

      OddsService.deleteOdd(itemDelete.id).then(success.bind(this), error.bind(this))

      function success() {
        this.state.odds.remove(itemDelete)
        var oddsCorrect = []
        for (var i = 0; i < this.state.odds.length; i++) {
          if (this.state.odds[i].q !== undefined) {
            if (this.state.odds[i].q['id-s'] === setDad.id) {
              oddsCorrect.push(this.state.odds[i])
            }
          } else {
            if (this.state.odds[i]['id-s'] === setDad.id) {
              oddsCorrect.push(this.state.odds[i])
            }
          }
        }
        setDad.q = oddsCorrect
        BundleCache.removeOddsOtherChannels(setDad)
        this.state.channels[indexDad].sets[indexSet].q[index].tog = false
        this.setState({
          odds: this.state.odds,
          channels: this.state.channels,
        })
      }

      function error(result) {
        this.state.channels[indexDad].q[index].tog = true
        this.setState({
          channels: this.state.channels,
        })
        swal(result.error.message)
      }
    },
    render: function () {
      return React.createElement(
        'table',
        { className: 'table' },
        React.createElement(
          'thead',
          null,
          React.createElement(
            'tr',
            { className: 'table-header' },
            React.createElement('th', null, 'Thumb'),
            React.createElement('th', null, 'Title'),
            React.createElement('th', null, 'Status'),
            React.createElement('th', null, '# of Cards'),
            React.createElement('th', null),
          ),
        ),
        this.state.channels.map(function (item, i) {
          var url = this.props.s3 + '/channels/' + item['img-t']
          var indexDad = i
          return React.createElement(
            'tbody',
            { key: i },
            React.createElement(
              'tr',
              null,
              React.createElement(
                'td',
                { style: { width: '230px' } },
                React.createElement('img', {
                  style: { height: '75px', width: '75px' },
                  'data-src': url,
                  className: 'lazyload',
                }),
              ),
              React.createElement('td', null, React.createElement('label', null, item.t)),
              React.createElement(
                'td',
                null,
                item.st === 1
                  ? React.createElement('label', null, 'Live')
                  : React.createElement('label', null, 'Pending'),
              ),
              React.createElement(
                'td',
                null,
                item.sets.length == 0
                  ? React.createElement('label', null, 'Expand to View')
                  : React.createElement('label', null, item.sets.length),
              ),
              React.createElement(
                'td',
                null,
                React.createElement(
                  'button',
                  {
                    style: { marginLeft: '20px' },
                    className: 'btn btn-default',
                    onClick: this.dataCollapseChannel.bind(this, i),
                  },
                  React.createElement(
                    'span',
                    null,
                    'Expand',
                    item.expand === true
                      ? React.createElement('i', {
                          className: 'fa fa-refresh fa-spin',
                        })
                      : React.createElement('span', null),
                  ),
                ),
              ),
            ),
            item.colapse === true
              ? React.createElement(
                  'tr',
                  null,
                  React.createElement(
                    'td',
                    {
                      colSpan: '9',
                      style: { paddingLeft: '40px', width: '100%' },
                    },
                    React.createElement(
                      'div',
                      null,
                      React.createElement(
                        'table',
                        { className: 'table' },
                        item.sets.map(function (set, setIdx) {
                          var idxSetDad = setIdx
                          var url = this.props.s3 + '/sets/' + set['img-t']
                          return React.createElement(
                            'tbody',
                            { key: setIdx },
                            React.createElement(
                              'tr',
                              { key: setIdx },
                              React.createElement(
                                'td',
                                { style: { width: '230px' } },
                                React.createElement('img', {
                                  style: { height: '75px', width: '75px' },
                                  'data-src': url,
                                  className: 'lazyload',
                                }),
                              ),
                              React.createElement(
                                'td',
                                { className: 'no-border-top' },
                                React.createElement('label', null, set.t),
                              ),
                              React.createElement(
                                'td',
                                null,
                                set.q === 1
                                  ? React.createElement('label', null, 'Live')
                                  : React.createElement('label', null, 'Pending'),
                              ),
                              React.createElement(
                                'td',
                                null,
                                set.q.length == 0
                                  ? React.createElement('label', null, 'Expand to View')
                                  : React.createElement('label', null, set.q.length),
                              ),
                              React.createElement(
                                'td',
                                null,
                                React.createElement(
                                  'button',
                                  {
                                    className: 'btn btn-default',
                                    onClick: this.saveAll.bind(this, indexDad, setIdx),
                                  },
                                  'Select All',
                                  set.expand === true
                                    ? React.createElement('i', {
                                        className: 'fa fa-refresh fa-spin',
                                      })
                                    : React.createElement('span', null),
                                ),
                                React.createElement(
                                  'button',
                                  {
                                    style: { marginLeft: '20px' },
                                    className: 'btn btn-default',
                                    onClick: this.dataCollapseSet.bind(this, indexDad, setIdx),
                                  },
                                  React.createElement(
                                    'span',
                                    null,
                                    'Expand',
                                    set.expand === true
                                      ? React.createElement('i', {
                                          className: 'fa fa-refresh fa-spin',
                                        })
                                      : React.createElement('span', null),
                                  ),
                                ),
                              ),
                            ),
                            set.colapse === true
                              ? React.createElement(
                                  'tr',
                                  null,
                                  React.createElement(
                                    'td',
                                    {
                                      colSpan: '9',
                                      style: {
                                        paddingLeft: '40px',
                                        width: '100%',
                                      },
                                    },
                                    React.createElement(
                                      'div',
                                      null,
                                      React.createElement(
                                        'table',
                                        { className: 'table' },
                                        React.createElement(
                                          'tbody',
                                          null,
                                          set.q.map(function (children, i) {
                                            var url = this.props.s3 + '/collectibles/' + children['img-t']
                                            return React.createElement(
                                              'tr',
                                              { key: i },
                                              React.createElement(
                                                'td',
                                                { className: 'no-border-top' },
                                                React.createElement('label', null, children.n),
                                              ),
                                              React.createElement(
                                                'td',
                                                { className: 'no-border-top' },
                                                React.createElement('img', {
                                                  style: {
                                                    height: '75px',
                                                    width: '75px',
                                                  },
                                                  'data-src': url,
                                                  className: 'lazyload',
                                                }),
                                              ),
                                              React.createElement(
                                                'td',
                                                { className: 'no-border-top' },
                                                React.createElement('label', null, children.t),
                                              ),
                                              React.createElement(
                                                'td',
                                                { className: 'no-border-top' },
                                                React.createElement('label', null, children.cr),
                                              ),
                                              React.createElement(
                                                'td',
                                                { className: 'no-border-top' },
                                                React.createElement('input', {
                                                  type: 'checkbox',
                                                  checked: children.tog,
                                                  onChange: this.toogleChange.bind(
                                                    this,
                                                    i,
                                                    indexDad,
                                                    idxSetDad,
                                                  ),
                                                }),
                                              ),
                                            )
                                          }, this),
                                        ),
                                      ),
                                    ),
                                  ),
                                )
                              : React.createElement('tr', null),
                          )
                        }, this),
                      ),
                    ),
                  ),
                )
              : React.createElement('tr', null),
          )
        }, this),
      )
    },
  })
}
